module.exports = __webpack_public_path__ + "static/plans-resource-selection-view-e80fc222a3f63ea24bbc09da1fee3599.png";